import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = { class: "text-subtitle" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(' ') + " ")
const _hoisted_7 = { key: 2 }

import { withDefaults, ref, onMounted } from 'vue'
import ConditionDialog from '@/components/Editor/Dialog/ConditionDialog/ConditionDialog.vue'
import Conditions from './components/Conditions.vue'
import { IConditionGroup, IStepData, IConditionField } from '@/interfaces/hoppermation'
import { readableConditionOperators, readableConditionScopes, readableNumberOperators } from '@/lib/helper'
import { AxiosInstance } from 'axios'
import createHoppermationAPIClient from '@/clients/hoppermation'
import bus from '@/lib/eventBus'
import EventNames from '@/lib/enums/eventNames'

interface IProps {
  updateNodeData?: (data: IStepData) => void
  details?: IStepData
}


export default /*#__PURE__*/_defineComponent({
  props: {
    updateNodeData: { type: Function, required: false, default: () => ({}) },
    details: { type: null, required: false, default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { updateNodeData: (data: IStepData) => void, details: IStepData }
const hoppermationApiClient = ref({} as AxiosInstance)
const conditionFields = ref([] as IConditionField[])

onMounted(async () => {
  hoppermationApiClient.value = await createHoppermationAPIClient()
  getConditionFields()
})

const getConditionFields = async (): Promise<void> => {
  try {
    const res = await hoppermationApiClient.value.get('/condition-fields')
    conditionFields.value = res.data
  } catch (error) {
    bus.$emit(EventNames.SHOW_SNACKBAR, { color: 'error', text: 'snackbar.channels.fetch.error' })
  }
}



const condition = ref(props.details.condition)

const editCondition = (updatedCondition: IConditionGroup): void => {
  if (condition.value) {
    condition.value = updatedCondition
    props.updateNodeData({ condition: condition.value })
  }
}

const deleteCondition = (index: number) => {
  condition.value?.conditions.splice(index, 1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('details.condition.conditions.title')), 1),
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.$t('details.condition.conditions.desc2.1')) + " ", 1),
      (condition.value?.operator)
        ? (_openBlock(), _createElementBlock("strong", _hoisted_4, _toDisplayString(_ctx.$t(_unref(readableConditionOperators)(condition.value.operator))), 1))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('details.condition.conditions.desc2.2')) + " ", 1),
      (condition.value?.scope)
        ? (_openBlock(), _createElementBlock("strong", _hoisted_5, _toDisplayString(_ctx.$t(_unref(readableConditionScopes)(condition.value.scope))), 1))
        : _createCommentVNode("", true),
      _hoisted_6,
      (condition.value?.count && condition.value?.countOperator)
        ? (_openBlock(), _createElementBlock("strong", _hoisted_7, _toDisplayString(_ctx.$t(_unref(readableNumberOperators)(condition.value?.countOperator))) + " " + _toDisplayString(condition.value?.count) + " " + _toDisplayString(_ctx.$t('details.condition.conditions.desc2.4')), 1))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('details.condition.conditions.desc2.3')), 1)
    ]),
    _createVNode(Conditions, {
      items: condition.value?.conditions,
      "remove-item": deleteCondition,
      "condition-fields": conditionFields.value
    }, null, 8, ["items", "condition-fields"]),
    _createVNode(ConditionDialog, {
      condition: condition.value,
      "edit-condition": editCondition,
      "condition-fields": conditionFields.value
    }, null, 8, ["condition", "condition-fields"])
  ]))
}
}

})